import { api } from './client.js';

export const templatesApi = {
  list: () => api.get('/templates').then((r) => r.data.templates),
  applyToPage: (templateId, pageId) =>
    api.post(`/templates/${templateId}/apply`, { page_id: pageId }).then((r) => r.data.page),
};
